import React from 'react'
import {
  CFView,
  CFText,
  CFImage,
  CFLink,
  DefaultScreen,
  MobileScreen,
} from 'components'
import Header from './Header'
import OrderPickupButton from './OrderPickupButton'
import OrderDeliveryButton from './OrderDeliveryButton'
import { hero, heroText, mobileHero, mobileHeroText } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView
          h="100vh"
          image={`url(${mobileHero}) center / cover no-repeat`}
          column
          alignCenter
        >
          <CFView textCenter w="100%">
            <CFView mv="3vh">
              <CFImage
                mt="4vh"
                w="85%"
                src={mobileHeroText}
                alt="Blue Coast Japanese Seafood Cuisine Restaurant hero text"
                zIndex={98}
              />
            </CFView>
            <CFView pulsate mt="25px">
              <OrderPickupButton />
            </CFView>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView
          h="100vh"
          maxHeight="680px"
          w="100%"
          image={`url(${hero}) 25% 0%/ cover no-repeat`}
          zIndex={90}
          column
          justifyStart
          alignStart
          pt="2%"
          pl="5%"
        >
          <CFImage
            src={heroText}
            h="85vh"
            maxHeight="500px"
            alt="Blue Coast Japanese Seafood Cuisine Restaurant hero text"
            zIndex={98}
          />
          <CFView pulsate mt="30px">
            <OrderPickupButton />
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
